import { render } from "./VacuumSetup.vue?vue&type=template&id=1b5dc7a0"
import script from "./VacuumSetup.vue?vue&type=script&lang=js"
export * from "./VacuumSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__